import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import EntryTypeInfo from './entryTypeInfo';
import { FaInfoCircle as InfoIcon } from 'react-icons/fa';

import CustomNumeral from '../../shared/customNumeral.component';
import { countryTaxTypeDescriptionsSelector } from '../../shared/store/selectors';

export const TaxEntryPropTypes = PropTypes.shape({
  businessUnit: PropTypes.string,
  taxYear: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  countryTaxType: PropTypes.string.isRequired,
  taxEntryTypeDescription: PropTypes.string,
  taxEntryActivityDescription: PropTypes.string,

  legalEntity: PropTypes.string,
  adjustmentDescription: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  taxEntryComment: PropTypes.string,
  netAmount: PropTypes.number,
  grossAmount: PropTypes.number,
  currencyCode: PropTypes.string,

  glAccountOffsetDescription: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  topsideFlag: PropTypes.string,
  fbosFlag: PropTypes.string,
  bookTypeDescription: PropTypes.string,

  taxEntryType: PropTypes.string,

  validationError: PropTypes.string,

}).isRequired;

class TaxEntryDetails extends PureComponent {
  static propTypes = {
    taxEntry: TaxEntryPropTypes,
    countryTaxTypesDescriptions: PropTypes.objectOf(PropTypes.string),
  };

  render() {
    const { taxEntry, countryTaxTypesDescriptions } = this.props;
    const {
      businessUnit,
      taxYear,
      countryTaxType,
      taxEntryTypeDescription,
      taxEntryActivityDescription,

      legalEntity,
      adjustmentDescription,
      taxEntryComment,
      netAmount,
      grossAmount,
      currencyCode,

      glAccountOffsetDescription,
      topsideFlag,
      fbosFlag,
      bookTypeDescription,

      taxEntryType,

      validationError,
    } = taxEntry;

    const countryTaxTypeDescription = countryTaxTypesDescriptions[countryTaxType];

    const netAmountWithCurrency = <span><CustomNumeral>{netAmount}</CustomNumeral> {currencyCode}</span>;
    const grossAmountWithCurrency = <span><CustomNumeral>{grossAmount}</CustomNumeral> {currencyCode}</span>;

    return (
      <div className="details-tab">
        {validationError ? (
          <div className="row mb-2">
            <div className="col">
              <span className="text-danger">{validationError}</span>
            </div>
          </div>
        ) : null}
        <div className="row content">
          <div className="col-12 col-sm-3">
            <div className="row">
              <div className="col-6">Business Unit</div>
              <div className="col-6 value">{businessUnit}</div>
              <div className="col-6">Tax Year</div>
              <div className="col-6 value">{taxYear}</div>
              <div className="col-6">Country Tax Type</div>
              <div className="col-6 value">{countryTaxTypeDescription}</div>
              <div className="col-6">Entry Type</div>
              <div className="col-6 value">{taxEntryTypeDescription}</div>
              <div className="col-6">Activity</div>
              <div className="col-6 value">{taxEntryActivityDescription}</div>
            </div>
          </div>
          <div className="col-12 col-sm-3">
            <div className="row">
              <div className="col-6">Legal Entity</div>
              <div className="col-6 value">{legalEntity}</div>
              <div className="col-6">Account</div>
              <div className="col-6 value">{adjustmentDescription}</div>
              <div className="col-6">Comments</div>
              <div className="col-6 value">{taxEntryComment}</div>
              <div className="col-6">Net Amount</div>
              <div className="col-6 value">{netAmountWithCurrency}</div>
              { grossAmount !== undefined && ( // eslint-disable-line no-undefined
                <>
                  <div className="col-6">Gross Amount</div>
                  <div className="col-6 value">{grossAmountWithCurrency}</div>
                </>
              )}
            </div>
          </div>
          <div className="col-12 col-sm-3">
            <div className="row">
              <div className="col-6">GL Account Offset</div>
              <div className="col-6 value">{glAccountOffsetDescription}</div>
              <div className="col-6">Topside</div>
              <div className="col-6 value">{topsideFlag}</div>
              <div className="col-6">Generate matching State and FBOS entries</div>
              <div className="col-6 value">{fbosFlag}</div>
              <div className="col-6">Book Type</div>
              <div className="col-6 value">{bookTypeDescription}</div>
            </div>
          </div>
          <div className="col-12 col-sm-3">
            <InfoIcon /> {EntryTypeInfo[taxEntryType]}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  countryTaxTypesDescriptions: countryTaxTypeDescriptionsSelector(state),
});

export default connect(mapStateToProps)(TaxEntryDetails);
